(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypeCheckController', TypeCheckController);

    TypeCheckController.$inject = ['GenericEntityDatatableService', 'CoreService', 'TypeCheck', '$q', '$uibModal',
        'ConfirmationService'];

    function TypeCheckController(GenericEntityDatatableService, CoreService, TypeCheck, $q, $uibModal,
                                 ConfirmationService) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Type of Check',
            newButtonTitle: 'New Type of Check',
            entityClassHumanized: 'Type of Check',
            entityStateName: 'type-check',
            service: TypeCheck,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Type of Check',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/type-check/update/type-check-dialog.html',
                controller: 'TypeCheckDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/type-check/update/type-check-dialog.html',
                controller: 'TypeCheckDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['TypeCheck', function (TypeCheck) {
                        return TypeCheck.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Type of Check').result.then(function () {
                    TypeCheck.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();
